import type {
  CreateTgChatBindingRequest,
  PersonalDigestReport,
  TgChatBindingDto,
  TgChatJoinDto,
  UpdateTgChatBindingRequest,
  UpdateTgNotificationSettingsRequest,
} from '@ledokol/contracts'
import { api } from './client'

/**
 * Эпик «TG welcome» W7 — клиенты для двух источников страницы /admin/tg-bindings:
 *  - `GET /tg_chat_bindings` — активные привязки (всегда есть project_id);
 *  - `GET /tg_chat_joins?has_binding=false` — orphan-чаты (бот добавлен, не привязан);
 *  - `POST/PATCH/DELETE /tg_chat_bindings` — CRUD admin'а.
 *
 * КРИТИЧНО: `tg_chat_id` — string ВЕЗДЕ (BigInt-safe из контрактов W2). Никаких
 * `parseInt`/`Number` на стороне web — потеря знака на супергрупповых `-100…`,
 * близких к 2^53.
 */

export async function fetchTgBindings(): Promise<TgChatBindingDto[]> {
  const r = await api.get<TgChatBindingDto[]>('/tg_chat_bindings')
  return r.data
}

export async function fetchOrphanChats(): Promise<TgChatJoinDto[]> {
  const r = await api.get<TgChatJoinDto[]>('/tg_chat_joins', { params: { has_binding: 'false' } })
  return r.data
}

export async function createTgBinding(body: CreateTgChatBindingRequest): Promise<TgChatBindingDto> {
  const r = await api.post<TgChatBindingDto>('/tg_chat_bindings', body)
  return r.data
}

export async function updateTgBinding(
  id: string,
  body: UpdateTgChatBindingRequest,
): Promise<TgChatBindingDto> {
  const r = await api.patch<TgChatBindingDto>(`/tg_chat_bindings/${id}`, body)
  return r.data
}

export async function deleteTgBinding(id: string): Promise<void> {
  await api.delete(`/tg_chat_bindings/${id}`)
}

/** #5 (2E) — группы с настройками уведомлений для экрана /admin/tg-notifications (право tg_notifications.manage). */
export async function fetchTgNotificationGroups(): Promise<TgChatBindingDto[]> {
  const r = await api.get<TgChatBindingDto[]>('/tg_chat_bindings/notification-settings')
  return r.data
}

/** #5 (2E) — настройки уведомлений группы (окно тишины + дайджест). Право tg_notifications.manage. */
export async function updateTgNotificationSettings(
  id: string,
  body: UpdateTgNotificationSettingsRequest,
): Promise<TgChatBindingDto> {
  const r = await api.patch<TgChatBindingDto>(`/tg_chat_bindings/${id}/notification-settings`, body)
  return r.data
}

/** #5 (2D/2E) — запросить мгновенную рассылку статуса во все активные группы. */
export async function broadcastTgStatus(): Promise<{ ok: boolean; active_chats: number }> {
  const r = await api.post<{ ok: boolean; active_chats: number }>('/tg_chat_bindings/broadcast-status', {})
  return r.data
}

/** #9 — разослать личную сводку выбранным сотрудникам; возвращает pre-flight отчёт. */
export async function sendPersonalDigest(userIds: string[]): Promise<PersonalDigestReport> {
  const r = await api.post<PersonalDigestReport>('/tg_chat_bindings/personal-digest', { user_ids: userIds })
  return r.data
}
